import { render, staticRenderFns } from "./CoachingPlatform.vue?vue&type=template&id=c665fc1e"
import script from "./CoachingPlatform.vue?vue&type=script&lang=js"
export * from "./CoachingPlatform.vue?vue&type=script&lang=js"
import style0 from "./CoachingPlatform.vue?vue&type=style&index=0&id=c665fc1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports